import { Section } from "../../../shared"
import ProjectsForm from "./form"
import { ImplementerProfileContext } from "../../../../contexts/implementer/profile"
import { useContext } from "react"

export function Projects() {
  const {
    updateGeneralInformation,
    loading,
    error,
    data,
    disabled = false
  } = useContext(ImplementerProfileContext)

  const onChange = data => {
    updateGeneralInformation({ projects: data })
  }

  return (
    <Section title={"2. Proyectos de implementadora donde no participa FICOSEC"}>

      <div style={{overflowWrap:"break-word", whiteSpace:"normal", marginBottom:"16px", fontSize:"13px", opacity:"50%"}}>
      Favor de cargar los proyectos que la Socia Implementadora ha tenido vigentes en los últimos 2 años de operación y el año actual.<br/>
      Si la socia implementadora tiene varios años trabajando con FICOSEC, deberá incluir información desde los dos años anteriores al inicio de la colaboración con FICOSEC hasta el año actual.<br/>
      Hay que tomar en consideración que este apartado te permitirá editar campos del apartado 3.
      </div>
      <ProjectsForm
        data={data}
        isLoading={loading}
        error={error}
        onChange={onChange}
        disabled={disabled} />
    </Section>
  )
}
